import DOMPurify from 'dompurify';

const sanitizeHtml = (html: string): string => {
    return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
    });
};

export default sanitizeHtml;
